var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/toggleButton.scss';
import { CheckedToggleButtonTypeClass, ToggleButtonTypeClass } from './ToggleButtonType';
import { SvgIcon } from '../SvgIcon/SvgIcon';
export const ToggleButton = (_a) => {
    var { text, icon, type, checked = false, disabled = false, className, onClick } = _a, restProps = __rest(_a, ["text", "icon", "type", "checked", "disabled", "className", "onClick"]);
    const toggleButtonClassNames = [
        'toggle-button',
        isValidString(text) ? '' : 'md',
        checked ? CheckedToggleButtonTypeClass[type] : ToggleButtonTypeClass[type],
        className
    ];
    const toggleButtonClassName = toggleButtonClassNames.filter(Boolean).join(' ');
    return (_jsxs("button", Object.assign({ className: toggleButtonClassName, onClick: onClick, disabled: disabled }, restProps, { children: [!isNullOrUndefined(icon) && _jsx(SvgIcon, { icon: icon }), isValidString(text) && _jsx("span", { className: "toggle-button-text", children: text })] })));
};
